import { render } from "./LuckyWheelPage.vue?vue&type=template&id=24c3d67c&scoped=true&ts=true"
import script from "./LuckyWheelPage.vue?vue&type=script&lang=ts"
export * from "./LuckyWheelPage.vue?vue&type=script&lang=ts"

import "./LuckyWheelPage.vue?vue&type=style&index=0&id=24c3d67c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c3d67c"]])

export default __exports__